module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/internal/_isRegExp.js
 ** module id = 257
 ** module chunks = 0
 **/